import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"

interface UseGenerateZipParams {
  eventVaultId: number
  albumId?: number
  options: IGenerateZipOptions
}
interface IGenerateZipOptions {
  groupByGuest?: boolean
  groupByAlbum?: boolean
  favouritesOnly?: boolean
}

export async function generateZip(eventVaultId: number, albumId?: number, options: IGenerateZipOptions = {}) {
  const query = new URLSearchParams()

  if (albumId)
    query.append("album", albumId.toString())
  if (options.favouritesOnly) {
    query.append("favouritesOnly", options.favouritesOnly.toString())
  }
  else {
    if (options.groupByAlbum)
      query.append("groupByAlbum", options.groupByAlbum.toString())
    if (options.groupByGuest)
      query.append("groupByGuest", options.groupByGuest.toString())
  }

  await axios.post(`/api/event/${eventVaultId}/generatezip?${query.toString()}`)
}

export function useGenerateZip() {
  return useMutation({
    mutationFn: ({ eventVaultId, albumId, options }: UseGenerateZipParams) => generateZip(eventVaultId, albumId, options),
  })
}
